export default (method, url, data = {}, target) => {
  const form = document.createElement("form");
  form.action = url;
  form.method = method;
  form.target = target || "_self";

  for (const key in data) {
    const input = document.createElement("textarea");
    input.name = key;
    input.value = typeof data[key] === "object"
      ? JSON.stringify(data[key])
      : data[key];
    form.appendChild(input);
  }

  form.style.display = 'none';
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};